import { CmsSectionsTypes } from 'models/Product';

import Component from './component';

export interface Props {
    sections: CmsSectionsTypes[]
}

export default Component;
